import { render, staticRenderFns } from "./ChapterView.vue?vue&type=template&id=6f954ac6&scoped=true"
import script from "./ChapterView.vue?vue&type=script&lang=js"
export * from "./ChapterView.vue?vue&type=script&lang=js"
import style0 from "./ChapterView.vue?vue&type=style&index=0&id=6f954ac6&prod&lang=scss"
import style1 from "./ChapterView.vue?vue&type=style&index=1&id=6f954ac6&prod&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "6f954ac6",
  null
  
)

/* custom blocks */
import block0 from "./ChapterView.vue?vue&type=custom&index=0&blockType=i18n"
if (typeof block0 === 'function') block0(component)

export default component.exports